import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { businessDayService } from './businessDay.service';
import { handleThunkError } from '../helpers/thunkError';

const initialState = {
  businessDays: null,
  loadingBusinessDays: false,
  error: null
};

// --- GET BUSINESS DAYS ---
export const getBusinessDays = createAsyncThunk(
  'businessDay/getBusinessDays',
  async (payload, thunkAPI) => {
    try {
      return await businessDayService.getBusinessDays(payload);
    } catch (error) {
      return handleThunkError(error, thunkAPI, 'Failed to fetch business days');
    }
  }
);

export const businessDaySlice = createSlice({
  name: 'businessDay',
  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder
      // --- GET BUSINESS DAYS ---
      .addCase(getBusinessDays.pending, (state) => {
        state.loadingBusinessDays = true;
        state.error = null;
        // Keep the existing businessDays while loading
      })
      .addCase(getBusinessDays.fulfilled, (state, action) => {
        state.loadingBusinessDays = false;
        state.businessDays = action.payload;
        state.error = null;
      })
      .addCase(getBusinessDays.rejected, (state, action) => {
        state.loadingBusinessDays = false;
        state.error = action.payload;
        // Keep the previous businessDays on error
      });
  }
});

export default businessDaySlice.reducer;
